import { SVGProps, Ref, forwardRef } from 'react';

export const IngotsFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M5.755 17.2c1.032.001 1.582.014 2.055.192.533.2 1 .548 1.342 1.003l.117.171c.256.418.422.985.718 1.992L11 24H0l.745-2.534c.596-2.025.902-3.052 1.678-3.649l.048-.036c.7-.51 1.619-.573 3.284-.58"
                fill="currentColor"
            />
            <path
                d="M17.51 17.2c2.162 0 3.244 0 4.043.598s1.104 1.635 1.714 3.709L24 24H12.876l-1.161-3.95c-.297-1.01-.553-1.977-1.125-2.736q-.046-.058-.092-.114z"
                fill="currentColor"
            />
            <path
                d="M13.41 8.713c-.572.76-.828 1.727-1.125 2.736L11.124 15.4H0l.733-2.493c.61-2.074.915-3.11 1.714-3.709.8-.598 1.88-.598 4.042-.598h7.013q-.047.055-.092.113"
                fill="currentColor"
            />
            <path
                d="M18.16 8.6c1.738.007 2.678.063 3.393.598.799.598 1.104 1.635 1.714 3.71L24 15.398H13l1.013-3.442c.338-1.15.507-1.727.835-2.162.3-.398.694-.715 1.145-.922l.197-.082c.46-.172.992-.189 1.97-.19"
                fill="currentColor"
            />
            <path
                d="M5.755 0C6.787.001 7.337.014 7.81.191c.533.2 1 .549 1.342 1.004l.117.171c.256.418.422.984.718 1.991L11 6.8H0l.742-2.525c.598-2.033.904-3.062 1.683-3.66l.043-.032C3.168.071 4.088.008 5.755 0"
                fill="currentColor"
            />
            <path
                d="M17.51 0c2.162 0 3.244 0 4.043.598s1.104 1.635 1.714 3.709L24 6.8H12.876l-1.161-3.95C11.418 1.84 11.162.873 10.59.113Q10.544.056 10.498 0z"
                fill="currentColor"
            />
        </g>
    </svg>
));
IngotsFilledSize24Glyph.displayName = 'IngotsFilledSize24Glyph';
